import { DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = {
  fonts: {
    regular: "'Gotham-Book', sans-serif",
    bold: "'Gotham-Bold', sans-serif",
  },
  colors: {
    primary: '#117EFF',
    secondary: '#1A1731',
    background: '#FAFBFF',
    textBody: '#3E4157',
    textLight: '#9196AB',
  },
};
